import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RecordingsStore, RecordingsState } from './recordings.store';
import { Recording, SortOption, OrderOption } from './recording.model';
import { ESearchScopes } from 'src/app/search/state/search-term.model';

@Injectable()
export class RecordingsQuery extends QueryEntity<RecordingsState, Recording> {
  selectSearchScope$: Observable<ESearchScopes> = this.select(state => state.ui.scope);
  selectVisibleRecordings$: Observable<Recording[]> = this.selectAll();

  selectTotal$: Observable<number> = this.select(state => state.page.total);

  selectTotalResults$: Observable<string> = this.selectTotal$.pipe(
    map(total => (total === 1 ? `${total.toLocaleString()} Result` : `${total.toLocaleString()} Results`))
  );

  selectOffset$: Observable<number> = this.select(state => state.page.offset);

  selectSortOptions$: Observable<SortOption[]> = this.select(state => state.sortOptions);
  selectSorting$: Observable<SortOption> = this.select(state => state.ui.sort);
  selectOrderOption$: Observable<OrderOption> = this.select(state => state.ui.sortOrder);

  getNextPage(aimsIsEnabled: boolean = false): {
    offset: number;
    hasNextPage: boolean;
  } {
    const state = this.getValue();
    const { page, ids } = state;
    const { total } = page;
    const pageSize = aimsIsEnabled ? 1 : page.pageSize;

    const hasNextPage = aimsIsEnabled ? !!ids.length : page.offset + pageSize < total;

    const offset = hasNextPage ? page.offset + pageSize : page.offset;

    return {
      offset,
      hasNextPage,
    };
  }

  constructor(protected store: RecordingsStore) {
    super(store);
  }
}
